import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import moment from 'moment'
import router from '../router';
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  partner: {},
  idToken: '',
  isContractExpired: false,
  expiredType: '',
  statusSearch: '',
  role: '',
  taskListId: '',
}

const getters = {
    GetPartner: state => {
        return state.partner
    },
    GetIdToken: state => {
        return state.idToken
    },
    GetIsContractExpired: state => {
        return state.isContractExpired
    },
    GetExpiredType: state => {
        return state.expiredType
    },
    GetStatusSearch: state => {
      return state.statusSearch
    },
    GetRole: state => {
      return state.role
    },
    GetTaskListId: state => {
      return state.taskListId
    },
}

const actions = {
    async fetchParter(state, idToken) {
      await axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/callback", {headers: {'Authorization': 'Bearer ' + idToken}})
        .then(response => {
          console.log(response.data)
          state.commit('setPartner', response.data)
          if(response.data.contract_end != null){
            if(! moment().isBefore(moment(response.data.contract_end))){
              state.commit('setPartner', {})
              state.commit('setIsContractExpired', true)
              state.commit('setExpiredType', 'after')
              router.push("/");
            }
          }

        }).catch(() => {
        })
    },
    clearDomain(state) {
        state.domain = ""
    }
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  setPartner (state, partner) {
    state.partner = partner
  },
  setIdToken (state, idToken) {
    state.idToken = idToken
  },
  setIsContractExpired (state, value) {
    state.isContractExpired = value
  },
  setExpiredType (state, type) {
    state.expiredType = type
  },
  setStatusSearch (state, type) {
    state.statusSearch = type
  },
  setRole (state, role) {
    state.role = role
  },
  setTaskListId (state, listId) {
    state.taskListId = listId
  },
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})

